var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corner forced-flex-wrapper"},[_c('b-container',{},[(_vm.corner)?[(false)?_c('hero',{attrs:{"corner":_vm.corner,"user":_vm.user}}):_vm._e(),(false)?_c('h5',[_vm._v(_vm._s(_vm.slug))]):_vm._e(),_c('life-time-analytics',{attrs:{"feedback":_vm.feedback}})]:_c('hero-skeleton')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }